import { createContext } from "react";
var DialogBackdropContext = /* @__PURE__ */createContext(void 0);
export { DialogBackdropContext as D };